import React from "react";
import logo from "../../assets/images/arcese_logo_text_red.svg";
import Button from "../ui/button/Button";
import { useTranslation } from "react-i18next";

const ApplicationError: React.FC = () => {
    const { t } = useTranslation();
    
    return (
        <div className="h-[100dvh] w-screen flex justify-center items-center">
            <div className="mb-16 w-screen">
                <div className="ml-10 mb-4 flex flex-col items-center">
                    <img src={logo} className="block h-[45px] w-auto" alt="Logo Arcese" />
                </div>
                <div className="text-center mb-3">{t('components.applicationError.text')}</div>
                <Button className="block mx-auto" callback={() => window.location.reload()}>{t('components.applicationError.reload')}</Button>
            </div>
        </div>
    )
}

export default ApplicationError;